// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 496 ? "graphql-print" : chunkId) + "." + {"496":"21b4462dabf43384","527":"fddd302c2052c6b0"}[chunkId] + ".js";
};